/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Col, Grid } from 'd2/components/Grid'
import { DEFAULT_COLLAPSED_HEIGHT } from './constants'
import { SPACING_ZERO } from 'd2/constants'
import { isNil } from 'lodash-es'
import {
  memo,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { px } from 'd2/utils/style'
import Button from 'd2/components/Button'
import Collapse from '@mui/material/Collapse'
import useStyles from './styles'
import useTranslations from './translations'
import type { Props } from './types'

const getCollapsed: (a?: boolean | null) => boolean = (value) => isNil(value) || value

const ShowMore = memo<Props>(({
  align,
  children,
  className,
  collapsedHeight,
  collapsedText,
  expandedText,
  onChangeCollapse,
  testID,
}) => {
  const t = useTranslations()
  const { classes, cx } = useStyles()
  const [collapsed, setCollapsed] = useState<boolean | null | undefined>(null)
  useEffect(() => {
    if (!isNil(collapsed)) {
      onChangeCollapse?.(collapsed)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapsed])

  const onClick = useCallback(() => setCollapsed((current) => !getCollapsed(current)), [])

  return (
    <Grid
      spacing={SPACING_ZERO}
    >
      <Col>
        <Collapse
          collapsedSize={px(isNil(collapsedHeight) ? DEFAULT_COLLAPSED_HEIGHT : collapsedHeight)}
          in={!getCollapsed(collapsed)}
        >
          { children }
        </Collapse>
      </Col>
      <Col className={cx({ [classes.textAlignCenter]: align === 'center' }, className)}>
        <Button
          blank
          link
          onClick={onClick}
          testID={`${testID || 'ShowMore'}-Button`}
          text={getCollapsed(collapsed)
            ? collapsedText || t.showMore
            : expandedText || t.showLess}
        />
      </Col>
    </Grid>
  )
})

ShowMore.displayName = 'ShowMore'

export default ShowMore
